import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutFuelReimbursementRateList extends Layout {
    layoutheaderFuelReimbursement: LayoutHeader;
    sourceFuelReimbursement: DataSource;
    tableFuelReimbursement: Table;
}
